import axios from '@src/utils/axios'

const module = 'candidate'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'paginationCompany': (ctx, data) => axiosInstance.get(`/${module}/paginate/company`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}`, data)
  },
  'getCandidateFiles':  (ctx, data) =>  axiosInstance.get(`/${module}/candidate_files`, {params:data}),
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },
  'findCandidate': (ctx, data) => axiosInstance.get(`/${module}/summary/` + data.id),
  'findUserCandidate': (ctx, data) => axiosInstance.get(`/${module}/user_candidate/` + data.job_id, {params:data}),
  'findByEmail': (ctx, data) => axiosInstance.get(`/${module}/find_by_email/` + data.email),

  'all': () => axiosInstance.get(`/${module}/all`),
  'uploadAvatar': (ctx, data) => axiosInstance.post(`/${module}/upload_avatar`, data),
  'createNote': (ctx, data) => axiosInstance.post(`/${module}/create_note`, data),
  'createSkill': (ctx, data) => axiosInstance.post(`/${module}/create_skill`, data),
  'removeSkill': (ctx, data) => axiosInstance.delete(`/${module}/remove_skill/` + data._id),

  'createTag': (ctx, data) => axiosInstance.post(`/${module}/create_tag`, data),
  'removeTag': (ctx, data) => axiosInstance.delete(`/${module}/remove_tag/` + data._id),

  'createEducation': (ctx, data) => axiosInstance.post(`/${module}/create_education`, data),
  'removeEducation': (ctx, data) => axiosInstance.delete(`/${module}/remove_education/` + data._id),
  'updateEducation': (ctx, data) => axiosInstance.put(`/${module}/update_education/` + data._id, data),

  'createWorkingExperience': (ctx, data) => axiosInstance.post(`/${module}/create_working_experience`, data),
  'removeWorkingExperience': (ctx, data) => axiosInstance.delete(`/${module}/remove_working_experience/` + data._id),
  'updateWorkingExperience': (ctx, data) => axiosInstance.put(`/${module}/update_working_experience/` + data._id, data),

  'uploadAttachment' : (ctx, data) => axiosInstance.post(`/${module}/upload_attachment`, data),
  'downloadAttachment' : (ctx, data) => axiosInstance.get(`/${module}/download_attachment`, {params:data}),
  'deleteAttachment' : (ctx, data) => axiosInstance.delete(`/${module}/delete_attachment/` + data.id),

  'scheduleInterview' : (ctx, data) => axiosInstance.post(`/${module}/schedule`, data),
  'getScheduledInterview' : (ctx, data) => axiosInstance.get(`/${module}/schedule/` + data),
  'removeScheduleInterview' : (ctx, data) => axiosInstance.delete(`/${module}/schedule/` + data._id),
  'removeScheduleInterviewByDate' : (ctx, data) => axiosInstance.delete(`/${module}/schedule_date/` + data._id),
  'saveNotifyCandidate' : (ctx, data) => axiosInstance.post(`/${module}/save_notify_schedule`, data),

  'getScheduledInterviewByToken': (ctx, data) => axiosInstance.get(`/${module}/schedule_by_token/` + data),

  'getFeedback': (ctx, data) => axiosInstance.get(`/${module}/feedback` , {params:data}),
  'addFeedback': (ctx, data) => axiosInstance.post(`/${module}/feedback`, data),
  'rejectApplication': (ctx, data) => axiosInstance.post(`/${module}/reject_application`, data),

  'getApplication': (ctx, data) => axiosInstance.get(`/${module}/application`, {params:data}),

  'confirmSchedule' : (ctx, data) => axiosInstance.post(`/${module}/confirm_schedule`, data),

  'getConfirmSchedule' : () => axiosInstance.get(`/${module}/confirm_schedule`),
  'reSchedule': (ctx, data) => axiosInstance.post(`/${module}/reschedule`, data),
  'placeCandidate' : (ctx, data) => axiosInstance.post(`/${module}/place_candidate`, data),
  'offerCandidate' : (ctx, data) => axiosInstance.post(`/${module}/offer_candidate`, data),
  'acceptOffer' : (ctx, data) => axiosInstance.post(`/${module}/accept_offer`, data),
  'declineOffer' : (ctx, data) => axiosInstance.post(`/${module}/decline_offer`, data),  
  'setAnotherInterview' : (ctx, data) => axiosInstance.post(`/${module}/another_interview`, data), 
  
  'sumbitCandidate': (ctx, data) => axiosInstance.post(`/${module}/sumbit_candidate`, data),
  'uploadTemporaryFiles': (ctx, data) => axiosInstance.post(`/${module}/upload_temporary_files`, data),

  'invite' : (ctx, data) => axiosInstance.post(`/${module}/invite`, data), 
  
}